export const siteUrl = "https://falsebayappliances.co.za/";
export const businessName = "Falsebay Appliances and Air-conditioning";
export const phoneDisplay = "+27 (0) 21 851 6890";
export const phoneHref = "tel:+27218516890";
export const phoneInternational = "+27218516890";
export const email = "Falsebayref@gmail.com";
export const emailHref = `mailto:${email}`;
export const address = "13 St James Street, Somerset West";
export const mapsUrl = "https://share.google/YsokcIvm8GXRQ1JKG";
export const serviceArea =
  "Gordon's Bay, Somerset West, Strand, Stellenbosch, and surrounding areas";

export const businessHours = [
  { days: "Monday-Friday", display: "08:00-17:00" },
  { days: "Saturday", display: "08:00-12:00" },
  { days: "Sunday", display: "Closed" },
];

export const faqItems = [
  {
    question: "Which household appliances do you repair?",
    answer:
      "We repair fridges, tumble dryers, dishwashers, and washing machines. We do not repair microwaves.",
  },
  {
    question: "Do you work with both homes and businesses?",
    answer:
      "Yes. We provide domestic appliance repairs as well as domestic and commercial refrigeration and air-conditioning services.",
  },
  {
    question: "Do you supply and service air conditioners?",
    answer:
      "Yes. We supply, install, service, and repair air-conditioning systems for homes and businesses.",
  },
  {
    question: "Which commercial refrigeration systems do you service?",
    answer:
      "We work on cold rooms, freezer rooms, shop refrigeration, display systems, and commercial ice machines. Ice machines are serviced and repaired; we do not supply ice.",
  },
  {
    question: "Which areas do you service?",
    answer: `We are based in Somerset West and service ${serviceArea}.`,
  },
  {
    question: "Do you offer appliance collection and delivery?",
    answer:
      "Yes. Fetch-and-deliver arrangements are available to make appliance repairs more convenient. Contact us to arrange a suitable time.",
  },
  {
    question: "What are your opening hours?",
    answer:
      "We are open Monday to Friday from 08:00 to 17:00 and Saturday from 08:00 to 12:00. We are closed on Sunday.",
  },
  {
    question: "How can I contact Falsebay Appliances and Air-conditioning?",
    answer: `Call ${phoneDisplay} or email ${email}. Our office is at ${address}.`,
  },
];

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${siteUrl}#business`,
  name: businessName,
  url: siteUrl,
  logo: `${siteUrl}assets/brand/logo.png`,
  image: `${siteUrl}assets/images/social/falsebay-social.jpg`,
  description:
    "A Somerset West business with more than 35 years of experience in appliance repairs, domestic and commercial refrigeration, and air-conditioning.",
  telephone: phoneInternational,
  email,
  address: {
    "@type": "PostalAddress",
    streetAddress: "13 St James Street",
    addressLocality: "Somerset West",
    addressRegion: "Western Cape",
    addressCountry: "ZA",
  },
  hasMap: mapsUrl,
  sameAs: [mapsUrl],
  areaServed: [
    "Somerset West",
    "Gordon's Bay",
    "Strand",
    "Stellenbosch",
  ].map((name) => ({ "@type": "City", name })),
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "08:00",
      closes: "17:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Saturday",
      opens: "08:00",
      closes: "12:00",
    },
  ],
  knowsAbout: [
    "Domestic appliance repairs",
    "Domestic refrigeration",
    "Commercial refrigeration",
    "Air-conditioning",
    "Cold rooms and freezer rooms",
    "Shop refrigeration",
    "Ice machine servicing and repairs",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Appliance, air-conditioning, and refrigeration services",
    itemListElement: [
      "Fridge, tumble dryer, dishwasher, and washing machine repairs",
      "Air-conditioning supply, installation, servicing, and repairs",
      "Domestic and commercial refrigeration servicing and repairs",
      "Cold room and freezer room construction",
      "Shop and display refrigeration servicing",
      "Commercial ice machine servicing and repairs",
    ].map((name) => ({
      "@type": "Offer",
      itemOffered: { "@type": "Service", name },
    })),
  },
};

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map(({ question, answer }) => ({
    "@type": "Question",
    name: question,
    acceptedAnswer: { "@type": "Answer", text: answer },
  })),
};
